import type * as React from "react";

import { AppsWidget } from "@/components/AppsWidget";
import { HideRSEButton } from "@/components/RSE/HideRSEButton";
import { RestoreSlidesButtons } from "@/components/RSE/RestoreSlidesButton";
import { SlideVisibilityWrapper } from "@/components/RSE/SlideVisibilityWrapper";
import { RSE_IFRAME_SLIDER_URL } from "@/config/settings";
import { NewsSlider } from "@/pages/ContactSelector/NewsSlider";
import {
    SMART_WIDGETS,
    WIDGET_LABELS,
} from "@/pages/RSEEditor/SmartAppsContext";

import "@/pages/ContactSelector/ContactSelectorPanel.css";
import "./PanelSmart.css";

const IframeSlider = () => {
    if (!RSE_IFRAME_SLIDER_URL) {
        return null;
    }
    return (
        <div className="iframe-slider">
            <iframe src={RSE_IFRAME_SLIDER_URL} className="w-100 h-100" />
        </div>
    );
};

const Content = () => {
    return (
        <>
            <NewsSlider />
            <IframeSlider />
            {SMART_WIDGETS.map((widget) => (
                <div key={widget}>
                    <AppsWidget widget={widget}>
                        <div>{WIDGET_LABELS[widget]}</div>
                    </AppsWidget>
                </div>
            ))}
        </>
    );
};

const TopBar = ({ onClose }: { onClose(): void }) => {
    return (
        <div
            className="text-right"
            style={{ marginTop: -20, marginRight: -16 }}
        >
            <RestoreSlidesButtons widget="smart-initial-slides" />
            <HideRSEButton callback={onClose} />
        </div>
    );
};

type Props = {
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};
export const PanelSmart = ({ setVisible }: Props): JSX.Element => {
    return (
        <SlideVisibilityWrapper
            setVisible={setVisible}
            href="/smart"
            className="smart-page"
        >
            <TopBar onClose={() => setVisible(false)} />
            <Content />
        </SlideVisibilityWrapper>
    );
};
